import { compile } from "path-to-regexp";
import { makeBackendPostCallWithJsonResponse } from "../../store/utils/fetch";
import { SUPPLY_CHAIN_UPDATE_FILE } from "../../store/utils/routes";
import { SupplyChainProductModel } from "./supplyChainModels";
import { promiseEngineEarsHandler } from "../helpers";

export enum SupplyChainRelatedType {
  Product = "product",
  Label = "label",
  Retailer = "retailer",
}

export enum SupplyChainFileAction {
  INSERT = 1,
  UPDATE = 2,
  DELETE = 3,
}

export enum SupplyChainFileType {
  IMAGE = 1,
  AUDIO = 2,
  VIDEO = 3,
  DDEX = 4,
  PDF = 5,
  DOLBY = 6,
  MOTION_DESKTOP = 7,
  MOTION_MOBILE = 8,
  CSV = 9,
  FONT = 10,
}

export interface SupplyChainFileParams {
  type: SupplyChainFileType;
  action: SupplyChainFileAction;
  // id only present if updating existing file.
  id?: number;
  original_file_name?: string;
  name?: string;
  filePath?: string;
}

export const postSupplyChainUpdateFile = async (
  productId: number,
  fileParams: SupplyChainFileParams,
) => {
  const route = compile(SUPPLY_CHAIN_UPDATE_FILE)({
    product_id: productId,
  });
  return makeBackendPostCallWithJsonResponse<SupplyChainProductModel>(
    route,
    fileParams,
  ).then(promiseEngineEarsHandler);
};
